import React from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
// import "../Dashboard.css";

const DashboardCard = ({
  dashboardData,
  second,
  heading,
  day,
  bgcolor,
  link,
}) => {
  return (
    <div className="col">
      <Link
        to={link}
        style={{
          textDecoration: "none",
        }}
      >
        <div
          className={bgcolor ? "second-cards-wrapper" : "hotel-cards-wrapper"}
          style={{ backgroundColor: bgcolor }}
        >
          <p className="card-heading">{heading}</p>
          <h1 className="mt-3">
            <CountUp end={dashboardData && second} />
          </h1>
          {/* <hr /> */}
          <p> {day}</p>
        </div>
      </Link>
    </div>
  );
};

export default DashboardCard;
